import { COVERGO_SAAS_DEV } from "../consts.js"

export const p_tenant_23_dev = {
	"p-tenant-23-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "p_tenant_23",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_SAAS_DEV,
	}
}
